import { dashboardApi } from '@/store/api/base/api.base';
import { sessionRefreshed } from '@/store/auth/auth.slice';
import type { TypeSessionUser, TypeUserPreferences } from '@/types/auth/types.auth.session';
import type { TypeMcpServer } from '@/types/profile/types.profile';
import type { TypePaletteColor } from '@/types/ui/types.ui.palette';

type TypeProfileInput = {
    displayName: string;
    jobTitle: string;
    phone: string;
    accentColor: TypePaletteColor;
};

const refreshUser = async (dispatch: (action: unknown) => unknown, queryFulfilled: Promise<{ data: TypeSessionUser }>) => {
    try {
        const { data } = await queryFulfilled;
        dispatch(sessionRefreshed(data));
    } catch {
    }
};

export const profileApi = dashboardApi.injectEndpoints({
    endpoints: (build) => ({
        readMcpServer: build.query<TypeMcpServer, void>({
            query: () => ({ url: '/mcp/server' }),
        }),

        updateProfile: build.mutation<TypeSessionUser, TypeProfileInput>({
            query: (profile) => ({ url: '/users/me/profile', method: 'patch', data: profile }),
            invalidatesTags: ['Person'],
            onQueryStarted: (_arg, { dispatch, queryFulfilled }) => refreshUser(dispatch, queryFulfilled),
        }),

        updateSignature: build.mutation<TypeSessionUser, string>({
            query: (signature) => ({ url: '/users/me/signature', method: 'patch', data: { signature } }),
            onQueryStarted: (_arg, { dispatch, queryFulfilled }) => refreshUser(dispatch, queryFulfilled),
        }),

        updatePreferences: build.mutation<TypeSessionUser, TypeUserPreferences>({
            query: (preferences) => ({ url: '/users/me/preferences', method: 'patch', data: preferences }),
            onQueryStarted: (_arg, { dispatch, queryFulfilled }) => refreshUser(dispatch, queryFulfilled),
        }),
    }),
});

export const {
    useReadMcpServerQuery,
    useUpdateProfileMutation,
    useUpdatePreferencesMutation,
    useUpdateSignatureMutation,
} = profileApi;

export default profileApi;
